/**
 * Main Styling File for Home Page
 *
 * @author Creator-Solutions -> Owen Burns
 */
import { NavLink as BaseNavLink } from "react-router-dom";

import styled from "styled-components";

interface PageProps {
  blur: boolean;
}

const HomePageContainer = styled.div<PageProps>`
  width: 99vw;
  height:auto;
  overflow: auto;
  .nav{
    backdrop-filter: blur(${p => p.blur ? '8px' : '0px'});
  }
`;

const FacebookMobileContainer = styled.div`
  width: 38vw;
  height: auto;
  flex-grow: 1;
  margin: 0px auto;
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 100vw;
    flex: 1;
  }
`;

const ProfileImageContainer = styled.div`
  width: 38vw;
  height: 50vh;
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 100vw;
  }
`;

const ProfileCoverImageContainer = styled.div`
  width: 100%;
  height: 35vh;
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 100vw;
  }
`;

const ProfileTopCover = styled.div`
  width: 38vw;
  height: 8vh;
  position: fixed;
  backdrop-filter: blur(8px);

  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 100vw;
  }
`;

const ProfileCoverImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ProfileImage = styled.img`
  width: 190px;
  height: 190px;
  border-radius: 50%;
  position: relative;
  left: 45px;
  bottom: 100px;
  border: 5px solid #fff;
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 150px;
    height: 150px;
    left: 25px;
  }
`;

const FollowButton = styled.button`
   width: 13vw;
   height: 5vh;
   margin: 10px 0px 0px 25px;
   border-radius: 20px;
   font-size: 18px;
   font-weight: 600;
   color: #fff;
   outline: none;
   border: none;
   background-color: #4169E1;

   &:hover{
      cursor: pointer;
   }

   @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 50vw;
  }
`

const ProfileContent = styled.div`
  width: 35vw;
  height: 30vh;
  margin: auto;
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 100vw;
    height: 35vh;;
  }
`;

const ProfileName = styled.h1`
  color: #fff;
  margin-left: 25px;
  display: flex;
  flex-direction: row;

  img {
    width: 25px;
    height: 25px;
    margin-left: 10px;
    align-self: center;
  }
`;

interface Props {
  margin: string;
  fontSize: string;
}

const Content = styled.p<Props>`
  color: #fff;
  font-size: ${(p) => p.fontSize};
  margin: ${(p) => p.margin};
`;

const FollowingContainer = styled.div`
  width: 30vw;
  height: 5vh;
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  p:first-child {
    margin-left: 25px;
  }

  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 100vw;
  }
`;

const Dot = styled.div`
  width: 5px;
  height: 5px;
  border-radius: 2px;
  align-self: center;
  background-color: #c0c0c0;
  margin-left: 10px;
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    align-self: center;
  }
`;

const FollowingContent = styled.p`
  color: #4169e1;
  font-size: 15px;
  align-self: center;
  font-weight: 600;
  margin-left: 15px;
`;

const NavBlock = styled.div`
  width: 38vw;
  height: 10vh;
  display: flex;
  flex-direction: row;
  justify-content: center;

  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 100vw;
    height: 7vh;
    margin-top: 25px;
  }
`;

const NavButtonCaption = styled(BaseNavLink)`
  width: 10vw;
  height: 7vh;
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  display: flex;
  align-self: center;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  &:hover {
    background-color: #212529;
  }
  span {
    width: 65%;
    height: 95%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &.active {
    span {
      border-bottom: 3px solid hsl(225, 73%, 57%);
    }
  }

  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 25vw;
  }
`;

const PageSubContent = styled.div`
  width: 38vw;
  flex: 1;
`;

export {
  Dot,
  Content,
  NavBlock,
  ProfileName,
  FollowButton,
  ProfileImage,
  PageSubContent,
  ProfileContent,
  ProfileTopCover,
  NavButtonCaption,
  FollowingContent,
  ProfileCoverImage,
  HomePageContainer,
  FollowingContainer,
  ProfileImageContainer,
  FacebookMobileContainer,
  ProfileCoverImageContainer,
};
